import React, { useState, useEffect } from 'react'
import { ServerConfig } from 'config'
import axios from 'axios'
import { useSelector } from 'react-redux'
import Progress from 'react-circle-progress-bar'
import { makeStyles } from '@material-ui/core/styles'
import {US_TIMEZONES} from 'utils/timezones'

// @material-ui/core components
import DatePicker from "react-datepicker";
import { Typography, Modal, Button, Box, Grid } from '@material-ui/core'
import _, { get } from 'lodash'

import LedgerComponent from './LedgerComponent'


const evt = new Event('customertable_is_dirty');


const useStyles = makeStyles((theme) => ({
  detailsBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: theme.palette.background.default,
    border: '2px solid #000',
    boxShadow: 24,
    padding: 4,
    maxHeight: '100vh', 
    overflowY: 'auto' 
  },
  fieldLabel: {
    display: 'block',
    width: '150px',
  },
  formGroup: {
    float: 'left',
    margin: '10px',
  },
  booleanField: {
    width: '256px'
  },
  formControl: {
    display: 'block',
    width: '256px',
  },
  detailsStatus: {
    lineHeight: '36px',
    padding: '10px'
  },
  errorMessage: { 
    color: 'red'
  },
  submitButton: {
    margin: '10px',
    display: 'block',
    float: 'left'
  },
  checkBoxContainer: {
    display: 'inlineBlock',
    verticalAlign: 'middle',
    lineHeight: '38px'
  },
  checkbox: {
    width: '20px',
    height: '20px',
    marginRight: '10px',
    verticalAlign: 'middle'
  },
  breakFloat: {
    clear: 'both'
  }
}))


const DetailsAddComponent = (props) => {
  const [details, setDetails] = useState({})
  const [operationtypes, setOperationtypes] = useState([])
  const [intervals, setIntervals] = useState([])
  const [devicetypes, setDevicetypes] = useState([])
  const [tenants, setTenants] = useState([])
  const [tenantsites, setTenantsites] = useState([])
  const [materials, setMaterials] = useState([])
  const [status, setStatus] = useState({ kind: "idle", message: "" }); 

  const classes = useStyles()
  const auth = useSelector(state => state.auth)

  const add_new_url = props.add_new_url;
  const editable_fields = props.editable_fields;


  // submit data and update object
  const handleSubmit = async (event) => {
    const config = { headers: { 'Content-Type': 'application/json' } }

    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }

    event.preventDefault();
    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    await axios.post(add_new_url, value, config)
    .then(response => {
      setStatus({ kind: "success", message: "Inserted" });
    }).catch(error => {
      if (error.response?.data?.msg) {
        setStatus({ kind: "error", message: error.response.data.msg });
      } else {
        setStatus({ kind: "error", message: 'Error inserting new record'});
      }
      return;
    });

    window.dispatchEvent(evt);
  }

  useEffect(() => {
      // get enum-values for select-field if needed
      const fetchOperationtypes = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/machines/operationtypes`, config)
        setOperationtypes(results.data)
      };

      const fetchDevicetypes = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/machines/devicetypes`, config)
        setDevicetypes(results.data)
      };

      const fetchIntervals = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/invoicing/intervals`, config)
        setIntervals(results.data)
      };

      const fetchTenants = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/tenants`, config)
        setTenants(results.data)
      }

      const fetchTenantSites = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/tenant_sites`, config)
        setTenantsites(results.data)
      }

      // get enum-values for materials
      const fetchMaterialtypes = async () => {
        const config = {headers:{'Content-Type':'application/json'}}

        if (auth.access_token) {
          config.headers.Authorization = `Bearer ${auth.access_token}`
        }

        const results = await axios.get(`${ServerConfig.SERVER_URL}/admin/materials`, config)
        setMaterials(results.data)
      };

    fetchMaterialtypes();
    fetchOperationtypes();
    fetchDevicetypes();
    fetchIntervals();
    fetchTenants();
    fetchTenantSites();
  }, [])

  const unsavedChanges = () => {
    setStatus({ kind: "info", message: "Unsaved changes"});
  }

  return (
    <>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        Details {details.id}
      </Typography>

      <hr />

      <form onSubmit={handleSubmit}>
        {
          editable_fields.map(function (fieldname, bla) {
            switch (fieldname[2]) {
              case "date":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input type="date" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue="" onChange={unsavedChanges} />
                </div>
              case "material":
                  return <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                      <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                        {_.map(materials, opt => { return (
                          (opt == details[fieldname[0]]) ? (<option selected value={opt}>{opt}</option>) : (<option value={opt}>{opt}</option>)
                          )
                          })}
                      </select>
                    </div>
              case "boolean":
                return <div className={`form-group ${classes.formGroup} ${classes.booleanField}`}>
                    <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                    <input type="hidden" name={fieldname[0]} value={false} />
                    <div className={classes.checkBoxContainer}>
                        <input type="checkbox" className={classes.checkbox} name={fieldname[0]} id={fieldname[0]} value={true} defaultChecked={details[fieldname[0]]} onChange={unsavedChanges} />{fieldname[1]}
                    </div>
                </div>
              case "devicetype":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                    <option selected value="ecocount">ecocount</option>
                    <option selected value="tablet">tablet</option>
                  </select>
                </div>
              case "tenant":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                    {_.map(tenants, opt => { return (
                      (opt.id == details[fieldname[0]]) ? (<option selected value={opt.id}>{opt.business_name}</option>) : (<option value={opt.id}>{opt.business_name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "tenant_optional":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]] || ""} onChange={unsavedChanges}>
                    <option value="">None</option>
                    {_.map(tenants, opt => { return (
                      (opt.id == details[fieldname[0]]) ? (<option selected value={opt.id}>{opt.business_name}</option>) : (<option value={opt.id}>{opt.business_name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "tenantsite":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                    <option value="">Please Select</option>
                    {_.map(tenantsites, opt => { return (
                      (opt.id == details[fieldname[0]]) ? (<option selected value={opt.id}>{opt.name}</option>) : (<option value={opt.id}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "operationtype":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                    {_.map(operationtypes, opt => { return (
                      (opt.id == details[fieldname[0]]) ? (<option selected value={opt.id}>{opt.name}</option>) : (<option value={opt.id}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "devicetype_name":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                    {_.map(devicetypes, opt => { return (
                      (opt.id == details[fieldname[0]]) ? (<option selected value={opt.name}>{opt.name}</option>) : (<option value={opt.name}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "interval_name":
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select className={`form-control ${classes.formControl}`} name={fieldname[0]} id={fieldname[0]} defaultValue={details[fieldname[0]]} onChange={unsavedChanges}>
                    {_.map(intervals, opt => { return (
                      (opt.name == details[fieldname[1]]) ? (<option selected value={opt.name}>{opt.name}</option>) : (<option value={opt.name}>{opt.name}</option>)
                      )
                      })}
                  </select>
                </div>
              case "hours":
                return
              case "tzid":
                  return (
                    <div className={`form-group ${classes.formGroup}`}>
                      <label htmlFor={fieldname[0]} className={classes.fieldLabel}>
                        {fieldname[1]}
                      </label>
                      <select
                        className={`form-control ${classes.formControl}`}
                        name={fieldname[0]}
                        id={fieldname[0]}
                        defaultValue={details[fieldname[0]] || "America/Los_Angeles"}
                        onChange={unsavedChanges}
                      >
                        {US_TIMEZONES.map((tz) => (
                          <option key={tz.value} value={tz.value}>
                            {tz.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
              case "keywords":
                return
              case "synonyms":
                return
              case "delete":
                return
              case 'textarea':
                const textareaRows = fieldname[3] || 6;  // default 6 if not specified
                return <div className={`form-group ${classes.formGroup} `}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <textarea
                    className="form-control"
                    name={fieldname[0]}
                    id={fieldname[0]}
                    rows={textareaRows}
                    onChange={unsavedChanges}
                    style={{ width: '100%', fontFamily: 'inherit' }}
                  />
                </div>
              case 'supportquestionstatus':
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <select
                    className={`form-control ${classes.formControl}`}
                    name={fieldname[0]}
                    id={fieldname[0]}
                    onChange={unsavedChanges}
                  >
                    <option value="draft">Draft</option>
                    <option value="published">Published</option>
                    <option value="archived">Archived</option>
                  </select>
                </div>
              default:
                return <div className={`form-group ${classes.formGroup}`}>
                  <label htmlFor={fieldname[0]} className={classes.fieldLabel}>{fieldname[1]}</label>
                  <input type="text" className="form-control" name={fieldname[0]} id={fieldname[0]} defaultValue="" onChange={unsavedChanges} />
                </div>
            }

          })
        }
        <br className={classes.breakFloat} />
        <Button type='submit' className={classes.submitButton}>Save</Button>
        <Typography id="details_status" variant="h6" component="h2" className={classes.detailsStatus}>
          {status.kind == "error" ? (<span className={classes.errorMessage}>ERROR: {status.message}</span>) : status.message}
        </Typography>
      </form>

    </>
  );
}

// handles button and modal overlay
const AddComponent = (props) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles()
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const auth = useSelector(state => state.auth)

  const editable_fields = props.editable_fields;
  const add_new_url = props.add_new_url

  useEffect(() => { }, [open]);

  return (
    <td>
      <Button onClick={handleOpen}>Add</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.detailsBox}>

          <DetailsAddComponent
            editable_fields={editable_fields}
            add_new_url={add_new_url}
          />
        </Box>
      </Modal>
    </td>
  );
};

export default AddComponent;
